import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon76: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#404040"
        d="m6.083 6.146 7.77 7.772a.5.5 0 0 1-.14.806L2.965 19.8a2.077 2.077 0 0 1-2.766-2.766l5.078-10.75a.5.5 0 0 1 .806-.14Zm-.205 1.209L1.103 17.462a1.079 1.079 0 0 0 1.434 1.434l10.107-4.773-6.766-6.768ZM16.5 11a.5.5 0 0 1 .5.5l-.001.5h.5a.5.5 0 0 1 .493.41l.008.09a.5.5 0 0 1-.5.5h-.501v.5a.5.5 0 0 1-.41.492L16.5 14a.5.5 0 0 1-.5-.5V13h-.5a.5.5 0 0 1-.491-.41L15 12.5a.5.5 0 0 1 .5-.5h.499v-.5a.5.5 0 0 1 .41-.492L16.5 11Zm3.353-.854a.5.5 0 1 1-.707.708c-1.562-1.562-3.73-1.562-5.293 0a.5.5 0 1 1-.707-.708c1.954-1.952 4.754-1.952 6.707 0Zm-4-6a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.707-.708l4-4a.5.5 0 0 1 .707 0Zm-6-4c1.954 1.953 1.954 4.755 0 6.708a.5.5 0 1 1-.707-.708c1.563-1.561 1.563-3.731 0-5.292a.5.5 0 0 1 .707-.708ZM7.5 2a.5.5 0 0 1 .5.5l-.001.5h.5a.5.5 0 0 1 .493.41L9 3.5a.5.5 0 0 1-.5.5h-.501v.5a.5.5 0 0 1-.41.492L7.5 5a.5.5 0 0 1-.5-.5V4h-.5a.5.5 0 0 1-.491-.41L6 3.5a.5.5 0 0 1 .5-.5h.499v-.5a.5.5 0 0 1 .41-.492L7.5 2Zm11-2a.5.5 0 0 1 .5.5l-.001.5h.5a.5.5 0 0 1 .493.41L20 1.5a.5.5 0 0 1-.5.5h-.501v.5a.5.5 0 0 1-.41.492L18.5 3a.5.5 0 0 1-.5-.5V2h-.5a.5.5 0 0 1-.491-.41L17 1.5a.5.5 0 0 1 .5-.5h.499V.5a.5.5 0 0 1 .41-.492L18.5 0Z"
      />
    </Svg>
  )
}
